import AsaasLogo from "./components/AsaasLogo";
import GoogleCalendarLogo from "./components/GoogleCalendarLogo";

export const INTEGRATIONS = [
	{
		id: "asaas",
		Logo: AsaasLogo,
		logoVariant: "wordmark",
		nameKey: "integrations.asaas.name",
		descriptionKey: "integrations.asaas.description",
		categoryKey: "integrations.asaas.category",
		status: "disconnected",
		docsUrl: "https://docs.asaas.com/",
	},
	{
		id: "google-calendar",
		Logo: GoogleCalendarLogo,
		logoVariant: "icon",
		nameKey: "integrations.googleCalendar.name",
		descriptionKey: "integrations.googleCalendar.description",
		categoryKey: "integrations.googleCalendar.category",
		status: "disconnected",
		docsUrl: null,
	},
];
